/**
 *
 * @param {object} next
 * @param {object} current
 * @return {boolean}
 */
export const propsIsChanged = (next, current) => {
    return Object.keys(next).some((key) => next[key] !== current[key])
}

/**
 *
 * @param {object} sources
 * @return {number}
 */
export const combineCostSources = (sources) =>
    sources
        ? Number(
              Object.keys(sources)
                  .reduce((acc, key) => acc + sources[key], 0)
                  .toFixed(2)
          )
        : 0

/**
 *
 * @param {number} x
 * @return {string}
 */
export function numberWithCommas(x) {
    let parts = x.toString().split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return parts.join('.')
}

/**
 *
 * @param {string} s
 * @return {*}
 */
export function toNameCase(s) {
    return `${s[0].toUpperCase()}${s.slice(1)}`
}

/**
 *
 * @type {{eur: string, gbp: string, usd: string, nok: string}}
 */
export const currencySymbols = {
    eur: '€',
    usd: '$',
    nok: 'kr',
    gbp: '£'
}

export const requireInt = (v) => {
    if (v === '') {
        return 0
    } else {
        v = typeof v === 'string' ? parseInt(v) : v
        if (!isNaN(v) && typeof v === 'number') {
            /*if (v > max) {
                onChange(max)
            } else {
                onChange(v)
            }*/
            if (v > 99999) {
                return 99999
            } else {
                return v
            }
        }
    }
}

/**
 * Use as onChange for inputs which should only accept and process numbers
 * @param {string|number} v
 * @param {function} callback
 */
export const handleNumberChange = (v, callback) => {
    if (v === '' || v === '0' || v === 0) {
        callback(0)
    } else {
        v = typeof v === 'string' ? parseInt(v) : v
        if (!isNaN(v)) {
            if (v > 99999) {
                callback(99999)
            } else {
                callback(v)
            }
        }
    }
}
